const sizes = {
  //   Phones
  minIphoneSeW: "320px",
  maxIphoneSeW: "375px",
  minIphone678W: "375px",
  maxIphone678W: "667px",
  minIphone678PlusW: "414px",
  maxIphone678PlusW: "736px",
  minIphoneXW: "375px",
  maxIphoneXW: "812px",
  minIphoneXRPlusW: "375px",
  maxIphoneXRPlusW: "430px",
  minIphoneXRPlusH: "812px",
  maxIphoneXRPlusH: "932px",
  minPixelW: "360px",
  maxPixelW: "412px",
  maxPixelH: "915px",
  //   Tablets
  minIpadMiniW: "768px",
  maxIpadMiniW: "1024px",
  minIpadAirW: "810px",
  maxIpadAirW: "834px",
  minIpadProW: "1024px",
  maxIpadProW: "1366px",
  minIpadProHeight: "1024px",
  maxIpadProHeight: "1366px",
  minTabletH: "800px",
  //   Laptops
  minLaptopW: "1200px",
  maxLaptopW: "1600px",
  //   PC
  minPCW: "1600px",
};

export const media = {
  /* ----------- Phones ----------- */
  iphoneSE: `@media only screen 
  and (min-device-width: ${sizes.minIphoneSeW}) 
  and (max-device-width: ${sizes.maxIphoneSeW}) 
  and (-webkit-min-device-pixel-ratio: 1)`,
  iphoneSEL: `@media only screen 
  and (min-device-width: ${sizes.minIphoneSeW}) 
  and (max-device-width: ${sizes.maxIphoneSeW}) 
  and (orientation: landscape) 
  and (-webkit-min-device-pixel-ratio: 1)`,
  phoneLansdscape: `@media only screen 
  and (max-width: 932px) 
  and (max-height: 800px) 
  and (orientation: landscape) 
  and (-webkit-min-device-pixel-ratio: 1)`,
  /* ----------- Tablets ----------- */
  ipadMini: `@media only screen 
  and (min-device-width: ${sizes.minIpadMiniW}) 
  and (max-device-width: ${sizes.maxIpadMiniW}) 
  and (min-device-height: ${sizes.minTabletH})
  and (-webkit-min-device-pixel-ratio: 1)`,
  ipadAir: `@media only screen 
    and (min-device-width: ${sizes.minIpadAirW}) 
    and (max-device-width: ${sizes.maxIpadAirW}) 
    and (min-device-height: ${sizes.minTabletH})
    and (-webkit-min-device-pixel-ratio: 2)`,
  ipadPro: `@media only screen 
  and (min-device-width: ${sizes.minIpadProW}) 
  and (max-device-width: ${sizes.maxIpadProW}) 
  and (min-device-height: ${sizes.minIpadProHeight}) 
    and (max-device-height: ${sizes.maxIpadProHeight}) 
  and (-webkit-min-device-pixel-ratio: 2)`,
  tablets: `@media only screen 
    and (min-width: 768px) 
    and (max-width: 1366px) 
    and (min-height: 800px)
    and (-webkit-min-device-pixel-ratio: 1)
    and (pointer: coarse)
    and (hover: none)
    and (orientation: portrait)`,
  tabletsL: `@media only screen 
    and (min-width: 768px) 
    and (max-width: 1366px)
    and (min-height: 600px) 
    and (-webkit-min-device-pixel-ratio: 1)
    and (pointer: coarse)
    and (hover: none)
    and (orientation: landscape)`,
  /* ----------- Laptops ----------- */
  laptop: `@media screen 
  and (min-width: ${sizes.minLaptopW}) 
  and (pointer: fine)
  and (hover: hover)
  and (-webkit-min-device-pixel-ratio: 1)`,
  /* ----------- PC ----------- */
  pc: `@media screen 
  and (min-device-width: ${sizes.minPCW})`,
};
